export const colors = {
	/** tons de cinza */
	greyscale: {
		/** #FFFFFF */
		white: "#ffffff",
		/** #CCCCCC */
		grey: "#CCCCCC",
		/** #DDDDDD */
		grey2: "#DDDDDD",
		/** #EEEEEE */
		light_grey: "#EEEEEE",
		/** #A5A5A5 */
		dark_grey: "#A5A5A5",
		/** #606060 */
		darker_grey: "#606060",
		/** #757575 */
		darker_grey2: "#757575",
		/** #444444 */
		semiblack: "#444444",
		/** #333333 */
		black: "#333333",
	},
	/** Cores principais */
	mainColors: {
		/** #CFEEFF */
		very_light_green: "#CFEEFF",
		/** #66D29C */
		light_verde_dstore: "#66D29C",
		/** #37C896 */
		verde_dstore: "#37C896",
		/** #29b383 */
		dark_verde_dstore: "#29b383",
		/** #8C50E6 */
		roxo_delinea: "#8C50E6",
		/** #505CCC */
		indigo: "#505CCC",
		/** #6473FF */
		blueberry: "#6473FF",
		/** #3b4df1 */
		hover_blueberry: "#3b4df1",
		/** #323A80 */
		minsk: "#323A80",
		/** #00C4FF */
		capri: "#00C4FF",
		/** #F39035 */
		orange: "#F39035",
		/** #c76d1a */
		dark_orange: "#c76d1a",
		/** #EC7D&D */
		crab_coral: "#EC7D7D",
		/** #F6F7FB */
		white_lilac: "#F6F7FB",
	},
	alertColors: {
		green_crayola: "#14CC70",
		tart_orange: "#FF4949",
		carmine_pink: "#E64141",
		beach_sand: "#FCD3A4",
		spanish_yellow: "#FFB70D",
		danger_red: "#C75136",
	},
	primary: {
		forest: "#28946E",
		light_green: "#F0FFFA",
	},
	warning: {
		orange_11: "#FFE9D6",
		orange_41: "#B65C12",
	},
	danger: {
		red_11: "#FFF3F0",
		red_41: "#C75136",
		red_71: "#943C28",
	},
};

export const grid_breakpoints = {
	xs: 0,
	sm: "576px",
	md: "768px",
	lg: "992px",
	xl: "1200px",
	xxl: "1400px",
};

export const lightTheme = {
	body: colors.greyscale.white,
	text: colors.greyscale.dark_grey,
	titles: colors.greyscale.black,
	subTitles: colors.greyscale.dark_grey,
	markText: colors.greyscale.darker_grey,
	placeholder: colors.greyscale.grey,
	inputBorder: colors.greyscale.grey,
	inputBorderFocus: colors.mainColors.verde_dstore,
	btnPrimary: colors.mainColors.verde_dstore,
	btnPrimaryHover: colors.mainColors.dark_verde_dstore,
	linkColor: colors.mainColors.verde_dstore,
	linkColorHover: colors.mainColors.dark_verde_dstore,
	menuItems: colors.greyscale.darker_grey,
	titleMaterials: colors.mainColors.blueberry,
};

export const darkTheme = {
	body: colors.greyscale.black,
	text: colors.greyscale.white,
	titles: colors.greyscale.white,
	subTitles: colors.greyscale.white,
	markText: colors.greyscale.white,
	placeholder: colors.greyscale.grey,
	inputBorder: colors.greyscale.grey,
	inputBorderFocus: colors.mainColors.verde_dstore,
	btnPrimary: colors.mainColors.verde_dstore,
	btnPrimaryHover: colors.mainColors.light_verde_dstore,
	linkColor: colors.mainColors.light_verde_dstore,
	linkColorHover: colors.mainColors.verde_dstore,
	menuItems: colors.greyscale.white,
	titleMaterials: colors.greyscale.white,
};
